import { Divider, Typography, Space } from 'antd'
{ Text, Title } = Typography

export fieldTypes = (isId = false) -> 
  if not isId
    (
      <Space direction="vertical" style={{ padding: 50, width: 500 }}>
        <Text>These correspond to the <i>type</i> of data you want to input. Different field types will require different configuration, lots of them shared between different field types.</Text>
        <Divider />
        <Text strong>String</Text>
        <Text>These are for recording textual properties, like names, or identifiers.</Text>
        <Text strong>Number</Text>
        <Text>No prizes for guessing that these are for recording numeric properties.</Text>
        <Text strong>Switch</Text>
        <Text>These are for recording true/false properties.</Text>
        <Text strong>Select</Text>
        <Text>These are for creating relations to nodes which already exist in the database.</Text>
        <Text strong>Select Or Create</Text>
        <Text>These are similar to <i>Select</i> fields, except they can also create nodes. They can (and must) reference another Form, which will be used to create the new node.</Text>
      </Space>
    )
  else
    (
        <Space direction="vertical" style={{ padding: 50, width: 500 }}>
          <Text>These correspond to the <i>type</i> of data you want to input. Different field types will require different configuration, lots of them shared between different field types.</Text>
          <Divider />
          <Text strong>String</Text>
          <Text>These are for recording textual properties, like names, or identifiers.</Text>
        </Space>
    )
  

export repeating = (
  <Space direction="vertical" style={{ padding: 10, width: 500 }}>
    <Text>If a field has <Text code>repeatOn</Text> configured, it will be repeated in the user form, based on the value of whatever was configured.</Text>
    <Text><Text mark>E.g.</Text>, if there is a <Text code>numberOfFriends</Text> number field somewhere else in the form, then a user might add a field <Text code>nameOfFriend</Text>, and configure it to repeat based on the number of friends the user selected.</Text>
    <Text strong>The form field that a <Text code>repeatOn</Text> refers to must appear in a previous form step.</Text>
    <Text>Values cannot be supplied from the same step, or from a future step.</Text>
  </Space>
)
